import React, { useEffect, useState } from "react";
import { H1, H3, H4 } from "@blueprintjs/core";
import CustomHr from "../common/CustomHr";
import { translate } from "utlis/translations/i18n";
import { Suggest } from "@blueprintjs/select";
import { Button } from "@blueprintjs/core";

const Introduction = ({
  session,
  protocol,
  playedTimes,
  results,
  onSelectName,
}) => {
  const today = new Date().toLocaleDateString("fr");
  //Stocke les noms des participants pour les utiliser dans le menu déroulant
  const [participantNames, setParticipantNames] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const [selectedName, setSelectedName] = useState(null);
  // const [inputValue, setInputValue] = useState("");

  //Cherche la propriété scores dans l'objet passé en paramètre, quelque soir sa structure
  const findScores = (obj) => {
    if (obj.scores) {
      return obj.scores;
    }

    for (let key in obj) {
      if (typeof obj[key] === "object") {
        const scores = findScores(obj[key]);
        if (scores) {
          return scores;
        }
      }
    }

    return null;
  };
  const handleItemSelect = (item) => {
    setSelectedName(item);
    onSelectName(item);
  };
  // Vide le champ de recherche et réinitialise le nom du participant sélectionné
  //Relance l'affichage des résultats pour tous les participants
  const handleReset = () => {
    setSelectedName("");
    // setInputValue("");
    onSelectName("");
    setResetKey((prevKey) => prevKey + 1);
  };
  // se déclenche lorsque 'results' change. Il extrait tous les noms de participants uniques des scores dans 'results' et met à jour l'état 'participantNames' avec ces noms.
  useEffect(() => {
    if (!results || !results.length) {
      return;
    }

    let names = [];

    results.forEach((result) => {
      const scores = findScores(result) || result.results;
      if (scores) {
        scores.forEach((score) => {
          if (score.participantName) {
            names.push(score.participantName); // Ajouter le nom du participant
          }
          if (score.voters) {
            names = [...names, ...score.voters]; // Ajouter les noms des votants
          }
        });
      }
    });

    names = Array.from(new Set(names)); // Supprime les doublons
    setParticipantNames(names); // Met à jour l'état avec les noms des participants
    // eslint-disable-next-line
  }, [results]);

  return (
    <div
      className="text-center"
      style={{ marginTop: "15px", marginBottom: "15px" }}
    >
      <H1 id="result">{session.metadata.name}</H1>
      <p className="margin-bottom-medium has-been-played">
        {translate("sessionHasBeenPlayed")} {playedTimes} {translate("times")}
      </p>
      <H3 id="result" className="margin-bottom-medium">
        {today}
      </H3>
      <H3 id="result" className="margin-bottom-medium">
        {translate("protocol")}: {protocol} <br /> <br />
        <br /> {session.metadata.context}
      </H3>

      {participantNames && participantNames.length > 0 && participantNames.some(name => name && name.trim() !== '') && (        
        <div>
          <H4 className="margin-bottom-medium" style={{ color: "white" }}>
            {translate("showResultsByParticipant")}
          </H4>
          <Suggest
            key={resetKey}
            items={participantNames}
            inputValueRenderer={(item) => item}
            onItemSelect={handleItemSelect}
            itemRenderer={(item, { handleClick }) => (
              <div
                style={{ cursor: "pointer" }}
                key={item}
                onClick={handleClick}
              >
                {item}
              </div>
            )}
            itemPredicate={(query, item) => {
              return item.toLowerCase().includes(query.toLowerCase());
            }}
            inputProps={{ placeholder: translate("participantsName") }}
          />

          {selectedName && (
            <Button
              intent="primary"
              minimal
              rightIcon="refresh"
              onClick={handleReset}
              style={{ marginLeft: "20px", color: "white" }}
            >
              {translate("reset")}
            </Button>
          )}
        </div>
      )}
      <CustomHr id="custom-hr-intro" />
    </div>
  );
};

export default Introduction;
